import peptLogo from '../assets/pept-logo-cropped.png';

export default function USBlockedPage() {
  return (
    <div className="min-h-screen bg-neutral-950 flex flex-col items-center justify-center p-6">
      {/* Logo */}
      <img 
        src={peptLogo} 
        alt="PEP-T" 
        className="h-20 mb-8"
      />
      
      {/* Main Message Box */}
      <div className="max-w-2xl w-full bg-neutral-900 border border-red-600/30 rounded-sm p-8 text-center">
        {/* Icon */}
        <div className="w-16 h-16 mx-auto mb-6 rounded-full bg-red-600/20 flex items-center justify-center">
          <svg 
            xmlns="http://www.w3.org/2000/svg" 
            className="h-8 w-8 text-red-500" 
            fill="none" 
            viewBox="0 0 24 24" 
            stroke="currentColor"
          >
            <path 
              strokeLinecap="round" 
              strokeLinejoin="round" 
              strokeWidth={2} 
              d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" 
            />
          </svg>
        </div>
        
        {/* Title */}
        <h1 className="text-2xl md:text-3xl font-bold text-white mb-4">
          Products Not Available in the United States
        </h1>
        
        {/* Message */}
        <p className="text-neutral-300 text-lg mb-6 leading-relaxed">
          The products commercialized by <span className="text-red-500 font-semibold">PEP-T</span> are 
          <strong className="text-white"> not available in the United States market</strong>.
        </p>
        
        <p className="text-neutral-400 mb-8">
          Our research chemicals are intended for <strong className="text-white">export only</strong> and 
          are not sold, distributed, or shipped to addresses within the United States of America.
        </p>

        {/* Divider */}
        <div className="border-t border-neutral-700 my-6"></div>

        {/* Legal Notice */}
        <div className="text-sm text-neutral-500">
          <p className="mb-2">
            In accordance with applicable regulations, PEP-T products are classified as 
            research chemicals intended for laboratory and scientific research purposes only.
          </p>
          <p>
            For international inquiries, please contact us at{' '}
            <a href="mailto:sales@pep-t.com" className="text-red-500 hover:underline">
              sales@pep-t.com
            </a>
          </p>
        </div>
      </div>

      {/* Footer */}
      <div className="mt-8 text-neutral-600 text-sm">
        © {new Date().getFullYear()} PEP-T.COM — Export Only
      </div>
    </div>
  );
}
